declare namespace $ {

	type $shm_hitalama_map_overlayed__entity_shm_hitalama_app_overlay_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_overlay['overlayed_map_entity'] >
		,
		ReturnType< $shm_hitalama_map_overlayed['entity'] >
	>
	type $mol_view__sub_shm_hitalama_app_overlay_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_overlay['overlayed_map_visible'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link_iconed__sub_shm_hitalama_app_overlay_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link_iconed['sub'] >
	>
	type $mol_link_iconed__uri_shm_hitalama_app_overlay_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_overlay['fullscreen_close_uri'] >
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_button_minor__hint_shm_hitalama_app_overlay_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_app_overlay_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_overlay['fullscreen_zoom_out'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_app_overlay_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_app_overlay_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_app_overlay_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_overlay['fullscreen_zoom_in'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_app_overlay_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_app_overlay_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_app_overlay extends $mol_view {
		overlayed_map_entity( ): any
		Overlayed_map( ): $shm_hitalama_map_overlayed
		overlayed_map_visible( ): readonly(any)[]
		Overlayed_map_holder( ): $mol_view
		Quick_access( ): $shm_hitalama_profile_quick
		Notifications( ): $shm_hitalama_notifications
		Fullscreen_close_icon( ): $mol_icon_arrow_expand_all
		fullscreen_close_uri( ): string
		Fullscreen_close( ): $mol_link_iconed
		fullscreen_zoom_out( next?: any ): any
		Fullscreen_zoom_out_icon( ): $mol_icon_magnify_minus
		Fullscreen_zoom_out( ): $mol_button_minor
		fullscreen_zoom_in( next?: any ): any
		Fullscreen_zoom_in_icon( ): $mol_icon_magnify_plus
		Fullscreen_zoom_in( ): $mol_button_minor
		Fullscreen_panel( ): $mol_view
		fullscreen_panel( ): readonly(any)[]
		hide_popover( ): any
		show_popover( id: any): any
		fullscreen_zoom( next?: number ): number
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=overlay.view.tree.d.ts.map